import {CSSProperties} from 'react';

export type MapLegendItem = {
    color: string;
    label: string;
};

interface ICategoricalLegendProps {
    type: 'categorical';
    title: string;
    items: MapLegendItem[];
}

interface IGradientLegendProps {
    type: 'gradient';
    title: string;
    gradientColors: string[];
    minLabel: string;
    maxLabel: string;
}

export type MapLegendProps = ICategoricalLegendProps | IGradientLegendProps;

const containerStyle: CSSProperties = {
    position: 'absolute',
    top: 8,
    right: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: 4,
    padding: '6px 8px',
    zIndex: 2,
    fontSize: 9,
    color: '#fff',
    lineHeight: 1.4,
    maxWidth: '40%',
};

const titleStyle: CSSProperties = {
    fontWeight: 700,
    marginBottom: 4,
    fontSize: 9,
};

const itemStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginBottom: 2,
};

const swatchStyle = (color: string): CSSProperties => ({
    width: 10,
    height: 10,
    borderRadius: 2,
    backgroundColor: color,
    flexShrink: 0,
});

const gradientBarStyle = (colors: string[]): CSSProperties => ({
    height: 8,
    borderRadius: 2,
    background: `linear-gradient(to right, ${colors.join(', ')})`,
    marginBottom: 2,
});

const gradientLabelsStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 8,
};

const MapLegend = (props: MapLegendProps) => {
    return (
        <div style={containerStyle}>
            <div style={titleStyle}>{props.title}</div>
            {props.type === 'categorical' && (
                props.items.map((item) => (
                    <div key={item.label} style={itemStyle}>
                        <span style={swatchStyle(item.color)} />
                        <span>{item.label}</span>
                    </div>
                ))
            )}
            {props.type === 'gradient' && (
                <>
                    <div style={gradientBarStyle(props.gradientColors)} />
                    <div style={gradientLabelsStyle}>
                        <span>{props.minLabel}</span>
                        <span>{props.maxLabel}</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default MapLegend;
